import { useCallback, useRef, useEffect, useState } from 'react';
import { track } from '@client/helpers/tracking';

export const useHidePopover = () => {
    const [showPopover, setShowPopover] = useState(true);

    const closePopover = useCallback(() => {
        setShowPopover(false);
    }, [setShowPopover]);

    return { showPopover, closePopover };
};

export const useGridTrack = (columnCount: number) => {
    const readyToTrack = useRef(false);

    useEffect(() => {
        if (!readyToTrack.current) {
            readyToTrack.current = true;

            return;
        }

        track('campaign_overview_change', { campaignColumns: columnCount });
    }, [columnCount]);
};
